import registerSliderStretcher from 'views/assets/scripts/registerSliderStretcher'
import runScripts from 'views/assets/scripts/runScripts'
import { initSlider } from 'views/assets/scripts/slider'

import handleZipCodes from './browser/handleZipCodes'

runScripts(initSlider, registerSliderStretcher, handleZipCodes)
